export const CREATE_TICKET = 'TICKETS::CREATE'
export const REDEEM_TICKETS = 'TICKETS::REDEEM'
export const REDEEM_TICKET = 'TICKET::REDEEM'



// WEBPACK FOOTER //
// ./src/types/actions/tickets.js